<template>
  <div class="box">
      <el-form autoComplete="on"
               :model="loginForm"
               :rules="loginRules"
               ref="loginForm"
               class="box-content"
               label-position="left">
        <h2 class="login-title">Sign In to KELLIOP</h2>
        <p style="font-size:18px;color:#343434;margin:63px 0 12px 0;">User ID:</p>
        <el-form-item prop="firstName">
          <el-input name="firstName" class="ipt"
                    type="text"
                    v-model="loginForm.firstName"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <p style="font-size:18px;color:#343434;margin:17px 0 8px 0;">Password:</p>
        <el-form-item prop="passWord">
          <el-input name="passWord" class="ipt"
                    :type="pwdType"
                    v-model="loginForm.passWord"
                    autoComplete="off"
                    placeholder="">
          </el-input>
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="pwdType === 'passWord' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
        <p style="font-size:18px;color:#343434;margin:24px 0;">Please be advised after five unsuccessful login attempts your account will be locked for 30 minutes.</p>
        <p @click="goPassword" style="font-size:18px;color:#00546a;margin-bottom:35px;"><a>Forgot your Password?</a></p>
        <el-form-item style="margin-bottom: 49px">
          <a class="loginBtn a1" :loading="loading" @click="handleLogin">
            LOGIN
          </a>
        </el-form-item>
        <p style="font-size:18px;color:#343434;margin-bottom:200px;">Don't have an account?<a style="color:#00546a;font-weight:bold;margin-left:14px;" @click="goRegister">Register Now</a></p>
      </el-form>
  </div>
</template>

<script>
  import {isvalidUsername} from '@/utils/validate';
  import { userLogin } from '@/api/index' ;

  const defaultlogin = {
    firstName: '',
    passWord: ''
  };
  export default {
    name: 'Login',

    data() {
      const validateUsername = (rule, value, callback) => {
        if (!isvalidUsername(value)) {
          callback(new Error('Please enter the correct username'))
        } else {
          callback()
        }
      };
      const validatePass = (rule, value, callback) => {
        if (value.length < 6) {
          callback(new Error('Password cannot be less than 6 digits'))
        } else {
          callback()
        }
      };
      return {
        loginForm: Object.assign({}, defaultlogin),
        loginRules: {
          firstName: [{required: true, trigger: 'blur', validator: validateUsername}],
          passWord: [{required: true, trigger: 'blur', validator: validatePass}]
        },
        loading: false,
        pwdType: 'passWord',
      }
    },
    methods: {
      showPwd() {
        if (this.pwdType === 'passWord') {
          this.pwdType = ''
        } else {
          this.pwdType = 'passWord'
        }
      },
      handleLogin() {
        console.log(333)
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.loading = true;
            userLogin(this.loginForm).then((res) => {
                console.log(res, 'login');
                this.loading = false
                localStorage.setItem('token', res.token)
                localStorage.setItem('userInfo', res)
                localStorage.setItem('firstName', res.firstName)
                this.$router.push({name: "PersonalInformation"});
                window.location.reload();
            }).catch(() => {
                this.loading = false
            });
          } else {
            return false
          }
        })
      },
      goRegister() {
        this.$router.push({name: "Register"});
      },
      goPassword() {
        this.$router.push({name: "Password"});
      },
    }
  }
</script>

<style scoped>
  .box{
    height:100%;
    width:100%;
    overflow: auto;
    min-height: 100vh;
    position: relative;
  }
  .box-content {
    /* width:550px;
    height:450px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 50px 0px rgba(232,62,66,0.12); */
    width:448px;
    position: absolute;
    left: 50%;
    top: 74px;
    transform: translateX(-50%);
    text-align:left;
    /* border-radius:22px; */
  }
  .login-title {
    font-size:30px;
    font-weight:bold;
    font-family:Arial;
    color:#000;
  }
  .ipt{
    width:423px;
    height:36px;
    /* border: 1px solid #e1e1e1 !important; */
    border: 0 !important;
    outline: none;
  }
  ::v-deep .el-input__inner {
    border-radius: 0 !important;
    border: 1px solid #e1e1e1 !important;
    background-color: #fff !important;
  }
  ::v-deep input:-internal-autofill-selected {
    background-color: #fff !important;
  }
  .loginBtn{
    width:225px;
    height:48px;
    background: #00718c;
    border-radius:6px;
    color: #ffffff;
    font-size:20px;
    font-weight:bold;
    display:block;
    text-align:center;
    line-height:48px;
  }
  .boxCon{
    text-align: center;
  }
  .titlelogo{
    width:103px;
    height:41px;
    font-size:50px;
    /* font-family:Adobe Heiti Std R; */
    font-family: "Arial";
    font-weight:bold;
    color:rgba(247,59,66,1);
    line-height:169px;
  }
  .titlecon{
    width:358px;
    height:38px;
    font-size:40px;
    /* font-family:FZLTZHK--GBK1-0; */
    font-family: "Arial";
    font-weight:normal;
    color:rgba(255,255,255,1);
    line-height:89px;
    text-shadow:0px 0px 10px rgba(0, 0, 0, 0.14);
  }
  .el-form-item__error{
    left: 50%;
  }
  .el-input__inner{
    background-color: red;
  }
</style>